import { useShadowRoot } from "@/helpers/ShadowRootContext.ts";
import { useState } from "react";

export interface CartDrawerState {
  open: boolean;
}

/**
 * Hook for cart drawer state — used on tablet/mobile to show/hide reservation sidebar
 */
export const useCartDrawerState = () => {
  const { containerEl } = useShadowRoot();
  const [cartDrawerState, setCartDrawerState] = useState<CartDrawerState>({
    open: false,
  });

  const handleOpenCartDrawer = () => {
    containerEl.classList.add("is-cart-drawer-opened");
    setCartDrawerState({ open: true });
  };
  const handleCloseCartDrawer = () => {
    containerEl.classList.remove("is-cart-drawer-opened");
    setCartDrawerState({ open: false });
  };

  return { cartDrawerState, handleOpenCartDrawer, handleCloseCartDrawer };
};
